import {connect} from "react-redux";
import React, {useContext} from "react";
import {apiIdle, apiRequest} from "../../data/redux/actions/api";
import {DimensionsContext, IS_WEB} from "../../common/utils/mobileUtils";
import {theme} from "../../common/theme/theme";
import {Linking, View} from "react-native";
import {useController} from "react-hook-form";
import {DialogM} from "../../common/components/alert/dialog/Dialog";
import {ListGroupM} from "../../common/components/list/ListGroupM";
import {ListItemM} from "../../common/components/list/ListItemM";
import moment from "moment/moment";
import {findClosestNextOccurrence} from "../../student/account/onboarding/LiveRoomCard";
import {useNavigation} from "@react-navigation/native";
import {ONE_OFF_ROOM_TYPES, oneOffLabel} from "../availability/releaseSlotsModel";

// The lives « Libérer des créneaux » places students from. A trial or a stage opens it too, on the live's own
// hour (ONE_OFF_ROOM_TYPES); only a permanence or a custom live stays with support.
const RELEASABLE_ROOM_TYPES = ["biweekly", "study_group", "individual", "holiday_workbook"]

const SelectSituationComponent = (props) => {
    const {
        typeData,
        control,
        goToNextStep,
        register,
        errors,
        serverError,
        setFormValues,
        formValues,
        field,
        liveSession,
        dateTime
    } = props;

    const dimensions = useContext(DimensionsContext);
    const navigation = useNavigation();

    const {field: situation} = useController({
        name: "type",
        control
    });

    const {field: newDate} = useController({
        name: "new_date",
        control
    });

    return (
        <>
            <View
                style={{
                    marginBottom: 10,
                    marginTop: 20,
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between"
                }}
            >
                <ListGroupM
                    options={typeData}
                    style={{
                        // marginHorizontal: 20
                        marginBottom: 70
                    }}
                    itemHeight={70}
                    renderItem={(item) => {
                        return (
                            <ListItemM
                                isFirst={item.index === 0}
                                isLast={item.index === typeData?.length - 1}
                                onPress={() => {
                                    const roomType = liveSession?.live_room?.type
                                    if (item.item?.value === "unavailable" && RELEASABLE_ROOM_TYPES.includes(roomType)) {
                                        navigation.push("tutor/liberer-creneaux", {liveSessionId: liveSession?.id});
                                        return;
                                    }
                                    if (item.item?.value === "unavailable" && ONE_OFF_ROOM_TYPES.includes(roomType)) {
                                        navigation.push("tutor/liberer-creneaux", {liveSessionId: liveSession?.id, oneOffLabel: oneOffLabel(roomType, liveSession?.day_time)});
                                        return;
                                    }
                                    if (item.item?.value === "unavailable" || item.item?.value === "other") {
                                        DialogM.show({
                                            text1:
                                                item.item?.value === "other" ? "Pour toute question, tu peux contacter le support" : "Pour les changements qui ne sont pas ponctuels, merci de contacter le support",
                                            buttonText1: "Contacter le support",
                                            buttonColor1: theme.colors.primary,
                                            onPress: () => {
                                                const whatsUpUrl = props.supportWhatsappUrl;
                                                if (IS_WEB)
                                                    window.open(whatsUpUrl, '_blank', 'noopener,noreferrer')
                                                else
                                                    Linking.openURL(whatsUpUrl).catch(err => console.error("Couldn't load page", err))
                                            },
                                            buttonText2: "Retour"
                                        });
                                        return;
                                    }

                                    const closestNextOccurrence = findClosestNextOccurrence([liveSession]);
                                    const liveMoment = closestNextOccurrence?.date
                                        ? moment(closestNextOccurrence?.date)
                                        : null;
                                    const date = dateTime ?? liveMoment.format("YYYY-MM-DD HH:mm");

                                    const newDateValue = item.item?.value === "one_occurrence" ? date : liveSession?.day_time
                                    // console.log("newDateValue", newDateValue)
                                    situation.onChange(item.item?.value);
                                    newDate.onChange(newDateValue);
                                    setFormValues({
                                        ...control?._formValues,
                                        type: item.item?.value,
                                        new_date: newDateValue
                                    });
                                    goToNextStep();
                                }}
                                itemHeight={70}
                                selected={item.item?.value === situation.value}
                                option={item.item}
                                disabled={item.item?.disabled}
                            />
                        );
                    }}
                />
            </View>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        supportWhatsappUrl: state.data.staticData?.support_whatsapp_url
    };
};

const mapDispatchToProps = {
    apiRequest,
    apiIdle
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectSituationComponent);
